<template>
    <div class="blog-sidebar-item">
        <h1 class="heading-border-bottom-anim" v-if="title">{{title}}</h1>
        <ul class="blog-sidebar-item-categories">
            <li v-for="item in categories" :key="item.id">
                <router-link :to="item.path">
                    <el-icon class="category-icon"><ArrowRight /></el-icon>{{item.title}} <span class="count">{{item.count}}</span>
                </router-link>
            </li>
        </ul>
    </div>
</template>


<script>
import {ArrowRight} from '@element-plus/icons-vue'

export default {
    name: 'BlogCategories',
    props: {
        title: {
            type: String,
            default: 'Categories'
        },
        categories: {
            type: Array,
            default: () => {}
        }
    },
    components: {
        ArrowRight
    }
}
</script>